import React, { useEffect, useState } from "react";
import Step1 from "./Step1";
import Step2 from "./Step2";
import { useLocation, useParams } from "react-router-dom";
import SelectApprovers from "./SelectApprovers";
import WorkItems from "./WorkItems";
import PreviewRFQ from "./PreviewRFQ";
import axios from "axios";

const RFQCreation = () => {
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [step, setStep] = useState(1);
  const [rfq, setRfq] = useState();
  const [fileNames, setFileNames] = useState({document: ""})
  const [fetching, setFetching] = useState(false);
  const {rfqId} = useParams();
  const location = useLocation();
  const [approvers, setApprovers] = useState({
    purchaseHead: "",
    awardee1: "",
    awardee2: "",
  });
  const [selectVendors, setSelectVendors] = useState([])

  const getDraft = async () => {
    setFetching(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/draft/get-by-id?draftRfqId=${rfqId}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setRfq({
        ...res.data,
        dept: res.data?.dept?.deptId
      });
      setFileNames({
        ...fileNames,
        document: res.data.documentFilename,
      })
    } catch (error) {
      console.log(error);
    } finally {
      setFetching(false);
    }
  };
  useEffect(() => {
    if (rfqId !== undefined) {
      getDraft();
    }
  }, [location]);

  return (
    <div style={{ position: "relative" }}>
      {fetching && <div className="loading-div"></div>}
        {step === 1 && <Step1 rfq={rfq} setRfq={setRfq} setStep={setStep} storedUser={storedUser} /> }
        {step === 2 && <Step2 rfq={rfq} setRfq={setRfq} setStep={setStep} storedUser={storedUser} fileNames={fileNames} setFileNames={setFileNames} /> }
        {step === 3 && <WorkItems rfq={rfq} setStep={setStep} user={storedUser} /> }
        {step === 4 && <SelectApprovers approvers={approvers} setApprovers={setApprovers} setStep={setStep} selectVendors={selectVendors} setSelectVendors={setSelectVendors} storedUser={storedUser} /> }
        {step === 5 && <PreviewRFQ rfq={rfq} approvers={approvers} setStep={setStep} user={storedUser} fileNames={fileNames} selectVendors={selectVendors} /> }
    </div>
  );
};

export default RFQCreation;
